import React from "react";
import styled from "styled-components";

function Header() {
     return (
          <StyleHeader>
               <p>My Todo List</p>
               <p>React</p>
          </StyleHeader>
     );
}

export default Header;

const StyleHeader = styled.div`
     width: 100%;
     display: flex;
     justify-content: space-between;
     margin: 0 auto;
     padding: 10px;
     font-size: 25px;
     font-weight: 600;
`;
